import { BN, Program } from "@coral-xyz/anchor";
import { vsrResolvers } from "./resolvers";
import { PROGRAM_ID } from "./constants";
export * from "./constants";
export * from "./pdas";
export * from "./resolvers";
export const init = async (provider, programId = PROGRAM_ID, idl) => {
    if (!idl) {
        idl = await Program.fetchIdl(programId, provider);
    }
    const heliumVoterStakeRegistry = new Program(idl, programId, provider, undefined, () => {
        return vsrResolvers;
    });
    return heliumVoterStakeRegistry;
};
export function isClaimed({ epoch, lastClaimedEpoch, claimedEpochsBitmap }) {
    if (epoch <= lastClaimedEpoch) {
        return true;
    }
    else if (epoch > lastClaimedEpoch + 128) {
        return false;
    }
    else {
        const bitIndex = epoch - lastClaimedEpoch - 1;
        return claimedEpochsBitmap.shrn(127 - bitIndex).and(new BN(1)).toNumber() === 1;
    }
}
//# sourceMappingURL=index.js.map